/* The collections holding a product that fits the shopper's machine, for the new header search's categories. */
(function () {
  'use strict';

  if (theme.searchMachineFits) return;

  const CACHE_PREFIX = 'search-machine-fits';
  // The storefront filter the fitment app's own collection links use; compatible_machines holds part-to-part fits too.
  const MACHINE_FILTER = 'filter.p.m.rpm_fitment.compatible_machines';
  const DATA_SELECTOR = '[data-machine-fits]';
  // 250 products a page (sections/predictive-search-machine-fits.liquid); more than this many pages isn't a machine's list.
  const MAX_PAGES = 8;
  // Parsed once per machine for the page.
  const sets = {};
  const inFlight = {};

  // The handles of every collection with a product that fits the machine, as a Set, if they've arrived; null until then.
  function ready(url, machineId) {
    if (!url || !machineId) return null;
    const key = cacheKey(machineId);
    if (sets[key]) return sets[key];
    const list = readCache(key);
    if (Array.isArray(list)) sets[key] = new Set(list);
    return sets[key] || null;
  }

  // Fetched at low priority, so a search's own request goes first, and kept for the session.
  function load(url, machineId) {
    const set = ready(url, machineId);
    if (!url || !machineId || set) return Promise.resolve(set);
    const key = cacheKey(machineId);
    if (!inFlight[key]) inFlight[key] = fetchAll(url, machineId).then((list) => keep(key, list)).finally(() => { delete inFlight[key]; });
    return inFlight[key];
  }

  function keep(key, list) {
    if (!list) return null;
    writeCache(key, list);
    sets[key] = new Set(list);
    return sets[key];
  }

  // The first page says how many there are; the others come in together.
  async function fetchAll(url, machineId) {
    const first = await fetchPage(pageUrl(url, machineId, 1));
    if (!first || first.pages > MAX_PAGES) return null;
    const pages = Array.from({ length: first.pages - 1 }, (unused, index) => pageUrl(url, machineId, index + 2));
    const rest = await Promise.all(pages.map(fetchPage));
    if (rest.some((page) => !page)) return null;
    return Array.from(new Set([first, ...rest].flatMap((page) => page.handles)));
  }

  function fetchPage(url) {
    return fetch(url, { priority: 'low' })
      .then((response) => (response.ok ? response.text() : null))
      .then((html) => (html === null ? null : parsePage(html)))
      .catch(() => null);
  }

  function pageUrl(url, machineId, page) {
    const target = new URL(url, window.location.origin);
    target.searchParams.set(MACHINE_FILTER, machineId);
    if (page > 1) target.searchParams.set('page', String(page));
    return target.toString();
  }

  function parsePage(html) {
    const holder = document.createElement('template');
    holder.innerHTML = html;
    const data = holder.content.querySelector(DATA_SELECTOR);
    if (!data) return null;
    try {
      const list = JSON.parse(data.textContent);
      if (!Array.isArray(list)) return null;
      return { handles: list.filter((handle) => typeof handle === 'string'), pages: parseInt(data.getAttribute('data-pages'), 10) || 1 };
    } catch (e) {
      return null;
    }
  }

  // Scoped like best sellers, as a signed-in buyer's catalogue can differ.
  function cacheKey(machineId) {
    const scope = theme.recentlyViewed && theme.recentlyViewed.cacheScope ? theme.recentlyViewed.cacheScope() : 'anon';
    return `${CACHE_PREFIX}-${scope}-${machineId}`;
  }

  function readCache(key) {
    try { return JSON.parse(sessionStorage.getItem(key)); } catch (e) { return null; }
  }

  function writeCache(key, list) {
    try { sessionStorage.setItem(key, JSON.stringify(list)); } catch (e) { /* quota or privacy mode: fetched again next time */ }
  }

  theme.searchMachineFits = { ready, load };
})();
